/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import React, { useEffect } from 'react';

import { useMachine } from '@xstate/react';
import { createMachine } from 'xstate';

import { actions } from './actions';
import { MACHINE_CONFIG } from './config';
import { services } from './services';

export const myProfilePageContext = React.createContext({});
export let myProfilePageMachine: any;

const MODULE_NAME = 'machines.pageContent';

export const useSMmyProfilePage = (_context: any) => {
  let _machineConfig: any = MACHINE_CONFIG;
  if (_machineConfig && _machineConfig?.context) {
    _machineConfig.context = {
      ..._machineConfig.context,
      ...(_context || {}),
    };
  }
  myProfilePageMachine = createMachine(_machineConfig, { services, actions });
  const [state, send] = useMachine(myProfilePageMachine);

  useEffect(() => {
    send({ type: 'START' });
  }, []);

  return {
    myProfilePageMachine,
    myProfilePageState: state,
    myProfilePageSend: send,
  };
};
